import apiClient from './client';

// ------------------------------------------------------------------
// 五维配置 —— 技能（AgentSkill）
// 复用主平台端点（/profiles/{profile_id}/skills）。
//   GET    /api/v1/profiles/{profile_id}/skills
//   POST   /api/v1/profiles/{profile_id}/skills
//   GET    /api/v1/profiles/{profile_id}/skills/{skill_id}
//   PUT    /api/v1/profiles/{profile_id}/skills/{skill_id}
//   DELETE /api/v1/profiles/{profile_id}/skills/{skill_id}
//   POST   /api/v1/profiles/{profile_id}/skills/{skill_id}/trust
// ------------------------------------------------------------------

export interface AgentSkill {
  id: string;
  profile_id?: string;
  name: string;
  display_name?: string;
  description?: string;
  category?: string;
  definition?: Record<string, unknown>;
  is_enabled?: boolean;
  trust_state?: string;
  created_at?: string;
}

export interface CreateSkillInput {
  name: string;
  /** 后端 create 必填（显示名），练玉坊 UI 用「名称」同时填充两者 */
  display_name?: string;
  description?: string;
  category?: string;
  definition?: Record<string, unknown>;
  is_enabled?: boolean;
}

export async function listSkills(profileId: string): Promise<AgentSkill[]> {
  const res = await apiClient.get<AgentSkill[]>(`/profiles/${profileId}/skills`);
  return res.data;
}

export async function createSkill(profileId: string, input: CreateSkillInput): Promise<AgentSkill> {
  const res = await apiClient.post<AgentSkill>(`/profiles/${profileId}/skills`, input);
  return res.data;
}

export async function updateSkill(
  profileId: string,
  skillId: string,
  input: Partial<CreateSkillInput>
): Promise<AgentSkill> {
  const res = await apiClient.put<AgentSkill>(`/profiles/${profileId}/skills/${skillId}`, input);
  return res.data;
}

export async function deleteSkill(profileId: string, skillId: string): Promise<void> {
  await apiClient.delete(`/profiles/${profileId}/skills/${skillId}`);
}
